import { useMutation } from "@tanstack/react-query";
import { enrollPaymentMethod } from "@/shared/api/payment";

export type EnrollPaymentMethodRequest = {
  return_url: string;
  email: string;
  make_charge: boolean;
};

export const useEnrollPaymentMethod = () => {
  return useMutation({
    mutationFn: (data: EnrollPaymentMethodRequest) => enrollPaymentMethod(data),
  });
};
